import styled from "styled-components";

import { SnackbarType } from "@sso/types";
import { RowContainer } from "@sso/ui/FlexBox";

interface PropsType {
  type: SnackbarType;
}

export const SnackbarBox = styled(RowContainer)<PropsType>`
  position: fixed;
  right: 10px;
  min-width: 40%;
  max-width: 95%;
  justify-content: flex-start;
  padding: 0.6rem 0.5rem;
  transition: all 0.5s ease-in-out;
  box-shadow: ${p => p.theme.shadows[3]};
  border-radius: ${p => p.theme.borderRadius};
  bottom: ${p => (p.open ? "10px" : "-110px")};
  opacity: ${p => (p.open ? 1 : 0)};
  z-index: ${p => p.theme.zIndex.snackbar};

  background-color: ${p => p.theme.colors[p.type].light};
  color: ${p => p.theme.colors[p.type].contrastText};
  @media (max-width: ${p => p.theme.breakpoints.sm}) {
    left: 10px;
  }
`;
